// extracted by mini-css-extract-plugin
module.exports =  {"root":"oZIVGiIohDyDtYmGcYA7","hours":"iPkvYuo4h5irpkkxCueA"};